import { Dropdown, DropdownButton } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

/**
 * 入力中の検索条件を引き継いで、他の一覧画面へ遷移するドロップダウン。
 */

// 遷移先の一覧。この並びがそのままメニューの並びになる
export const TRANSITION_TARGETS = [
  { key: 'clientmanage', name: '顧客台帳', path: '/admin/clientmanage' },
  { key: 'quoteRequests', name: '見積台帳', path: '/admin/quoteRequests' },
  { key: 'constructionRequests', name: '工事台帳', path: '/admin/constructionRequests' },
  { key: 'constructionSchedule', name: '工程表', path: '/admin/constructionSchedule' },
  { key: 'InspectionSchedule', name: 'アフター管理表', path: '/admin/InspectionSchedule' },
];

/**
 * 遷移先へ渡す検索条件を組み立てる。
 * 期間条件は遷移先の既定（全期間）にしたいので、明示的に空で上書きする。
 * @param {object} searchCondition 遷移元の検索条件
 */
export const buildTransitionCondition = (searchCondition) => ({
  KEYWORD: searchCondition?.KEYWORD ?? '',
  // 受付日（見積台帳）
  UKE_DATE_START: '',
  UKE_DATE_END: '',
  // 実績日（工事台帳）
  ACTUAL_DATE_START: '',
  ACTUAL_DATE_END: '',
  // 契約日（工程表）
  KEI_DATE_START: '',
  KEI_DATE_END: '',
  // 点検予定月（アフター管理表）。null を渡すと遷移先の既定期間が使われる
  PLAN_DATE_START: null,
  PLAN_DATE_END: null,
});

/**
 * @param {string} current 表示中の画面のキー（TRANSITION_TARGETS の key）
 * @param {object} searchCondition 引き継ぐ検索条件
 * @param {string} title ボタンの表示名
 */
function ScreenTransitionMenu({ current, searchCondition, title = '他の一覧で検索' }) {
  const navigate = useNavigate();

  // 表示中の画面は遷移先に出さない
  const targets = TRANSITION_TARGETS.filter((x) => x.key !== current);

  const handleSelect = (path) => {
    navigate(path, {
      state: { searchCondition: buildTransitionCondition(searchCondition) },
    });
  };

  return (
    <DropdownButton
      id={`screen-transition-${current}`}
      variant="primary"
      size="sm"
      className="d-inline-block ml-2"
      title={title}
    >
      {targets.map((x) => (
        <Dropdown.Item
          key={x.key}
          onClick={() => handleSelect(x.path)}
          title={`入力中の条件で${x.name}を検索します`}
        >
          {x.name}
        </Dropdown.Item>
      ))}
    </DropdownButton>
  );
}

export default ScreenTransitionMenu;
